export default {
  dispositivos: [],
}
